<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">
      {{
        helper.trans(`antifraudalerts.description.${alert.rule}.default`, {
          old: data?._oldDevice?.name ?? 'n/a',
          new: data?._newDevice?.name ?? 'n/a',
          req: data?._requisite?.requisites
        })
      }}</span>
    </div>
    <div v-if="data?.trafficBlocked" class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ helper.trans('labels.traffic_blocked')}}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType, reactive, toRefs} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import CopyButton from "@/components/CopyButton.vue";
import RequisiteDeviceChangeCheckDataDTO from "@/models/AntiFraud/RequisiteDeviceChangeCheckDataDTO";
import {requisitesRepository, traderDeviceRepository} from "@/service/repository/repositories";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";

export default defineComponent({
  name: "RequisitesDeviceChangeCheckDescription",
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {

    const state = reactive({
      data: null as RequisiteDeviceChangeCheckDataDTO|null
    });


    onMounted(async () => {
      if (props.alert) {
        state.data = {...props.alert.data} as unknown as RequisiteDeviceChangeCheckDataDTO

        if (state.data.newDeviceId) {
          traderDeviceRepository.getById(state.data.newDeviceId).then((item: TraderDeviceDTO) => {
            state.data!._newDevice = item
          })
        }

        if (state.data.oldDeviceId) {
          traderDeviceRepository.getById(state.data.oldDeviceId).then((item: TraderDeviceDTO) => {
            state.data!._oldDevice = item
          })
        }

        requisitesRepository.getById(state.data.requisiteId.toString()).then((item: TraderRequisitesDTO) => {
          state.data!._requisite = item
        })
      }
    });

    return {
      ...toRefs(state),
      helper,
      numberFormatter,
    }
  }
})
</script>
